import css from './sass/style.scss';

require('./js/anims')
require('./js/cards')
require('./js/carousels')
require('./js/init')
require('./js/list')
require('./js/methods')
require('./js/newsletter')
require('./js/polyfills')
require('./js/scrollpos')
require('./js/speech')
require('./js/sticky')
require('./js/widget')
